import React, { useCallback } from "react";

import { Dropdown } from "react-bootstrap";

import * as firebase from "firebase/app";
import "firebase/auth";

import { useHistory, Link } from "react-router-dom";
import DefaultAvatar from "./defaultAvatar";

const Header = (props) => {
  const history = useHistory();
  const logout = () => {
    firebase.auth().signOut();
    history.push("");
  };

  const mainNavTrigger = useCallback(() => {
    let oldState = props.mainNavToggle;
    props.setMainNavToggle(!oldState);
  }, [props]);

  return (
    <header className="header">
      <nav className="nav">
        <h1 className="nav__title">
          <Link to="/app">Mate</Link>
        </h1>

        <button className="nav__chatBtn" onClick={() => mainNavTrigger()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className="svg-inline--fa fa-chevron-left fa-w-10"
            data-icon="chevron-left"
            data-prefix="fas"
            viewBox="0 0 320 512"
          >
            <path
              fill="#e38930"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            ></path>
          </svg>
        </button>

        {/* <ul className="nav__list">
          <li
            className={`nav__el ${url.pathname === "/app" && "nav__el--focus"}`}
          >
            <Link to="/app">Accueil</Link>
          </li>
          <li onClick={() => mainNavTrigger()} className="nav__el">
            <button>Chats</button>
          </li>
          <li
            className={`nav__el ${
              url.pathname.substr(5) === "profil/" + props.userId &&
              "nav__el--focus"
            }`}
          >
            <Link to={`/app/profil/${props.userId}`}>Mon profil</Link>
          </li>
        </ul> */}
      </nav>

      <Dropdown className="avatar">
        <Dropdown.Toggle as={DefaultAvatar} pseudo={props.pseudo} />
        <Dropdown.Menu>
          <Dropdown.Item as={Link} to={`/app/profil/${props.userId}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              className="svg-inline--fa fa-user fa-w-14"
              data-icon="user"
              data-prefix="fas"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
              ></path>
            </svg>{" "}
            Mon profil
          </Dropdown.Item>
          <Dropdown.Item
            className="btn--logOut"
            as="button"
            onClick={() => logout()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              className="svg-inline--fa fa-sign-out-alt fa-w-16"
              data-icon="sign-out-alt"
              data-prefix="fas"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
              ></path>
            </svg>
            Se déconnecter
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </header>
  );
};

export default Header;
